package com.algorix.web

import org.jetbrains.compose.web.renderComposable

fun main() {
    I18n.init()
    renderComposable(rootElementId = "root") {
        App()
    }
}
